export default "__VITE_ASSET__46d94789__"